module.exports = __webpack_public_path__ + "img/star-full.2a3217ea.svg";